<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6" xs="12">
          <b-card no-body class="p-4">
            <b-card-body v-loading="isRequesting">
              <form @keyup.enter="login">

                <img src="/static/img/logo.png" alt="logo" width="200" class="p-2">
                <div class="input-group mb-3">
                  <span class="input-group-addon"><i class="icon-user"></i></span>
                  <input type="text" class="form-control" placeholder="Email" v-model="email">
                </div>
                <div class="input-group mb-4">
                  <span class="input-group-addon"><i class="icon-lock"></i></span>
                  <input type="password" class="form-control" placeholder="Password" v-model="password" name="password" current-password />
                </div>
                <b-row>
                  <b-col cols="12">
                    <p v-if="isUnauthorized" class="text-danger">Credenciais Inválidas</p>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="6">
                    <a :href="urlEsqueceuSenha"> Esqueceu a senha?</a>
                  </b-col>
                  <b-col cols="6" class="text-right">
                    <b-button variant="primary" class="px-4"   @click="login">
                      Login
                    </b-button>
                  </b-col>
                </b-row>
              </form>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
  import {mapActions, mapState} from 'vuex'
  import {Notification} from 'element-ui'

  export default {
    name: 'auth',
    data() {
      return {
        isUnauthorized: false,
        isRequesting: false,
        email: '',
        password: ''
      }
    },
    methods: {
      ...mapActions('Auth', ['doLogin']),
      ...mapActions(['init']),
      async login(e) {
        e.preventDefault()
        this.isRequesting = true
        this.isUnauthorized = false
        const {email, password} = this
        try {
          await this.doLogin({email, password})
          await this.init()
          document.body.classList.remove('login-body')
          if (this.redirect) {
            this.$router.push({name: this.redirect})
            return
          }
          this.$router.push({name: 'Home'})
        } catch (error) {

          if (!error.response) {
              Notification.error("Sem Conexão com o servidor!")
            return
          }

          if (error.response.status === 401) {
            this.isUnauthorized = true
          }

        } finally {
          this.isRequesting = false
        }

      }
    },
    computed: {
      ...mapState('Auth', ['isLoading']),
      ...mapState(['redirect']),
      urlEsqueceuSenha()
      {
        return process.env.API_URL_PASSWORD_RESET
      }
    },
    mounted() {
      document.body.classList.add('login-body')
    }
  }
</script>
<style>
  .login-body {
    background: rgba(0, 0, 0, 0) url('/static/img/bg_cool.jpg') no-repeat fixed center center / cover;
  }
</style>



// WEBPACK FOOTER //
// src/features/Auth/index.vue